import {
  emailBlockSchema,
  type IEmailBlockSchema,
} from "@redotech/redo-model/email-template";
import { savedEmailSectionSchema } from "@redotech/redo-model/saved-email-section";
import * as z from "zod";

export const updateSavedEmailSection = {
  name: "updateSavedEmailSection" as const,
  input: z.object({
    sectionId: z.string(),
    updates: z.object({
      name: z.string().optional(),
      blocks: z.array(emailBlockSchema as IEmailBlockSchema).optional(),
    }),
  }),
  output: savedEmailSectionSchema,
};
